
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/department/[...department]",
      function () {
        return require("private-next-pages/department/[...department].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/department/[...department]"])
      });
    }
  